/**
 * CfssWorkerManagementPage — Participant/RP worker management
 *
 * MN 256B.85: Participant-directed services - participant is the employer
 * Thin wrapper around shared WorkerManagementPage with CFSS config.
 *
 * Route: /cfss/workers
 */

import { WorkerManagementPage } from '@/pages/shared-services';

export function CfssWorkerManagementPage() {
  return (
    <WorkerManagementPage
      title="My Workers"
      subtitle="Manage your CFSS support workers"
      workerLabel="Worker"
      workerRoleId="pca-worker"
      edgeType="EMPLOYS"
      scope="cfss:worker:manage"
    />
  );
}

export default CfssWorkerManagementPage;
